import { useEffect, useMemo, useState } from 'react';
import useTravelerLabel from '../useTravelerLabel';
import useTravelerError from '../useTravelerError';
import { DEFAULT_MAX_TRAVELERS } from '../constants';
const defaultInitialValues = {
  rooms: 1,
  adults: 1,
  children: 0,
  childrenAges: {},
  lapInfants: 0
};
function useTravelerSelection({
  ageSelectEnabled,
  errorMessage: externalErrorMessage,
  initialValues,
  isInternationalFlight,
  isWhiteLabel,
  maxTravelers,
  shouldCountLapInfant = false,
  shouldAllowInternationalLapInfants
}) {
  const startValues = useMemo(() => ({
    ...defaultInitialValues,
    ...initialValues
  }), [initialValues]);
  const [rooms, setRooms] = useState(startValues.rooms);
  const [adults, setAdults] = useState(startValues.adults);
  const [children, setChildren] = useState(startValues.children);
  const [childrenAges, setChildrenAges] = useState(startValues.childrenAges);
  const [lapInfants, setLapInfants] = useState(startValues.lapInfants);
  const [errorMessage, setErrorMessage] = useState(null);
  const label = useTravelerLabel({
    adults,
    children,
    lapInfants,
    rooms
  });
  const calculatedErrorMessage = externalErrorMessage ? externalErrorMessage : useTravelerError({
    children,
    childrenAges,
    lapInfants,
    ageSelectEnabled,
    isInternationalFlight,
    isWhiteLabel,
    shouldAllowInternationalLapInfants
  });
  if (calculatedErrorMessage !== errorMessage) {
    setErrorMessage(calculatedErrorMessage);
  }
  useEffect(() => {
    setRooms(startValues.rooms);
    setAdults(startValues.adults);
    setChildren(startValues.children);
    setChildrenAges(startValues.childrenAges);
    setLapInfants(startValues.lapInfants);
  }, [startValues]);
  const passengerCount = adults + children + (shouldCountLapInfant ? lapInfants : 0);
  const remainingTravelerCount = Math.max((maxTravelers || DEFAULT_MAX_TRAVELERS) - passengerCount, 0);
  const removeChildrenAge = index => {
    const copy = childrenAges;
    delete copy[index];
    setChildrenAges(copy);
  };
  const onAdultsChange = count => {
    setAdults(count);
    if (count < lapInfants) {
      setLapInfants(count);
    }
  };
  const onChildrenChange = count => {
    setChildren(count);
    removeChildrenAge(count);
  };
  const onAgesChange = (index, value) => {
    setChildrenAges({
      ...childrenAges,
      [index]: value
    });
  };
  return {
    label,
    errorMessage,
    rooms,
    adults,
    children,
    childrenAges,
    lapInfants,
    remainingTravelerCount,
    setRooms,
    setAdults: onAdultsChange,
    setChildren: onChildrenChange,
    setChildrenAges: onAgesChange,
    setLapInfants
  };
}
export default useTravelerSelection;